import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CodeList from '../components/Codes/CodeList';
import { getCodes } from "./../actions/codes";
import { getDepositsMovements } from "./../actions/deposits";
import { getCredits } from "./../actions/credits";
import { connect } from 'react-redux';
import CreditList from '../components/Credits/CreditList';
import moment from 'moment'
import StandardAccordion from '../components/Complements/StandardAccordion';
import DepositList from '../components/Deposits/DepositList';
import Alert from '@material-ui/lab/Alert';


class CodesContainer extends Component {
    state = {
        codes:[],
        codespaginate:[],
        deposits: [],
        depositsPaginate: [],
        count:1,
        page:1,
        dateValue: JSON.stringify({month: moment().month(), year: moment().year()}),
        dateStart: new Date(moment().startOf('month')),
        dateEnd: new Date(moment().endOf('month')),
        dateStartDeposits: new Date(moment().startOf('month')),
        dateEndDeposits: new Date(moment().endOf('month')),
        dateStartCredits: new Date(moment().startOf('month')),
        dateEndCredits: new Date(moment().endOf('month')),
        credits: [],
        secuencialAccount: 0,
        loading: false,
        loadingCredits: false,
        depositSelected: {}
    };
    componentDidMount(){
        moment.locale('es-es')
       const {  dateStart, dateEnd } = this.state
       const {  balances, deposits, credits } = this.props
       let dateStartSend = (dateStart.getFullYear() -1) + "-" + (dateStart.getMonth() +1) + "-" + dateStart.getDate()
        if (balances.length > 0) {
            this.props.getCodes(dateStartSend,  moment(dateEnd).format('YYYY-MM-DD'), balances[0].Secuencial).then( res => {
             this.setState({ codes: res.payload.data.MovimientosCuenta, secuencialAccount: balances[0].Secuencial })
                let InitialDate = (dateStart.getFullYear()) + "-" + (dateStart.getMonth() +1) + "-" + dateStart.getDate()
                this.filterCodesByDate(InitialDate, moment(dateEnd).format('YYYY-MM-DD'))
            }).catch( error => {
                //console.log('no se a podido encontrar codes', error)
            })
        }
        let InitialDate = (dateStart.getFullYear()) + "-" + (dateStart.getMonth() +1) + "-" + dateStart.getDate()
        if (deposits.info.length > 0 ) {
            this.setState({ deposits: deposits.movements, depositSelected: deposits.info[0] })
            this.filterDepositsByDate(InitialDate, moment(dateEnd).format('YYYY-MM-DD'))
        } else {
            this.setState({ deposits: [], depositSelected: [] })
        }
        if (credits.infoPayment.length > 0 ) {
            this.setState({ credits: credits.tablePayment.PagosPrestamo })
        } else {
            this.setState({ credits: [] })
        }
       
    }

    onChangePaginationCodes = (e, page) => {
        const { codes } = this.state;
        let init = (page - 1) * 5;
        let end = page * 5;
        let datacodespaginate = [];
        datacodespaginate = codes.slice(init, end);
        this.setState({codespaginate: datacodespaginate, page : page})
    }

    onChangePaginationDeposits = (e, page) => {
        const { deposits } = this.state;
        let init = (page - 1) * 5;
        let end = page * 5;
        let dataDepositsPaginate = [];
        dataDepositsPaginate = deposits.slice(init, end);
        this.setState({depositsPaginate: dataDepositsPaginate, page : page})
    }

    // functions
    dateComare = (start, end, date) => {
            return (start <= date) && (end >= date)
    }

    filterDatesCredits = () => {
        try {
            const {  dateStartCredits, dateEndCredits } = this.state
            const { credits } = this.props
            const filterDates = (obj) => {
                if (new Date(obj.FechaVencimiento) >= new Date(dateStartCredits) && (new Date(obj.FechaVencimiento) <= new Date(dateEndCredits))) {
                    return true
                } else { return false }
            }
            const filtersCredits = credits.tablePayment.PagosPrestamo.filter(filterDates)
            this.setState({loadingCredits: false})
            this.setState({credits: filtersCredits})
        } catch (error) {
            //console.log(error)
        }
        
    }
    // mayor
    dateAfter = (str1, str2) =>
    {
        
        return new Date(str1) >= new Date(str2);
    }
    // menor
    dateBefore = (str1, str2) =>
    {
        return new Date(str1) <= new Date(str2);
    }

    getDataViewTable = (codes) => {
        let datacodespaginate = [];
        let count = parseInt((codes.length / 5).toString());
        let residuo = codes.length % 5;

        if(residuo > 0){
            count++;
        }

        if(codes.length > 0){
            datacodespaginate = codes.slice(0, 5);
        }

        this.setState({codespaginate: datacodespaginate, count : count, page : 1})
    }

    getDataViewTableDeposits = (deposits) => {
        let dataDepositsPaginate = [];
        let count = parseInt((deposits.length / 5).toString());
        let residuo = deposits.length % 5;

        if(residuo > 0){
            count++;
        }

        if(deposits.length > 0){
            dataDepositsPaginate = deposits.slice(0, 5);
        }

        this.setState({depositsPaginate: dataDepositsPaginate, count : count, page : 1})
    }

    filterCodesByDate = (dateStart,  dateEnd) => {
        const { codes } = this.props;
        const dataResult = codes.filter((code) => {
            let dateFormat = moment(code.Fecha, 'DD/MM/YYYY').format('YYYY-MM-DD')
            if (this.dateAfter(dateFormat, dateStart) && this.dateBefore(dateFormat, dateEnd)) {
                return true
            } else {
                return false
            }
        })

        this.getDataViewTable(dataResult);
        this.setState({codes: dataResult})
    }

    filterDepositsByDate = (dateStart,  dateEnd) => {
        try {
            const { deposits } = this.props;
            const dataResult = deposits.movements.filter((deposit) => {
                let dateFormat = moment(deposit.Fecha, 'DD/MM/YYYY').format('YYYY-MM-DD')
                if (this.dateAfter(dateFormat, dateStart) && this.dateBefore(dateFormat, dateEnd)) {
                    return true
                } else {
                    return false
                }
            })
            this.getDataViewTableDeposits(dataResult);
            this.setState({deposits: dataResult})
        } catch (error) {
            //console.log('error filterDepositsByDate ', error)
        }
        
    }

    filterCreditsByDate = (dateStart,  dateEnd) => {
        try {
            const { credits } = this.state;
            const dataResult = credits.filter((credit) => {
                let dateFormat = moment(credit.FechaVencimiento, 'DD/MM/YYYY').format('YYYY-MM-DD')
                if (this.dateAfter(dateFormat, dateStart) && this.dateBefore(dateFormat, dateEnd)) {
                    return true
                } else {
                    return false
                }
            })
            // this.getDataViewTableDeposits(dataResult);
            this.setState({credits: dataResult})
        } catch (error) {
            //console.log('error filterCreditsByDate ', error)
        }
        
    }
    //handle
    handleSelectCode = (val) => {
        this.setState({dateValue: val, loading: true, codes: this.props.codes})
        if (val === 'Todos los movimientos') {
            this.setState({  loading: false, codes: this.props.codes })
            this.getDataViewTable(this.props.codes);
        } else {
            let obj = JSON.parse(val)
            if (this.state.codes.length > 0) {
                let selectMonth = new Date(obj.year, obj.month, 1)
                let dateStart = moment(selectMonth).startOf('month').format('YYYY-MM-DD')
                let dateEnd = moment(selectMonth).endOf('month').format('YYYY-MM-DD')
                this.filterCodesByDate(dateStart, dateEnd)
                this.setState({ dateValue: val, loading: false })
            } else {
                this.getDataViewTable(this.props.codes);
                this.setState({  loading: false })
            }
        }
        
    }

    handleSelectDeposit = (val) => {
        try {
            this.setState({dateValue: val, loading: true, deposits: this.props.deposits.movements})
            if (val === 'Todos los movimientos') {
                this.setState({  loading: false, deposits: this.props.deposits.movements })
                this.getDataViewTableDeposits(this.props.deposits.movements);
            } else {
                let obj = JSON.parse(val)
                if (this.state.deposits.length > 0) {
                    let selectMonth = new Date(obj.year, obj.month, 1)
                    let dateStart = moment(selectMonth).startOf('month').format('YYYY-MM-DD')
                    let dateEnd = moment(selectMonth).endOf('month').format('YYYY-MM-DD')
                    this.filterDepositsByDate(dateStart, dateEnd)
                    this.setState({ dateValue: val, loading: false })
                } else {
                    this.getDataViewTableDeposits(this.props.deposits.movements);
                    this.setState({  loading: false })
                }
            }
        } catch (error) {
            //console.log(error)
        }
        
        
    }

    
    handleDateStart = (date) => {
        this.setState({dateStart: date})
    }
    handleDateEnd = (date) => {
        this.setState({dateEnd: date})
    }
    
    handleDateStartDeposits = (date) => {
        this.setState({dateStartDeposits: date})
    }
    handleDateEndDeposits = (date) => {
        this.setState({dateEndDeposits: date})
    }

    handleDateStartCredits = (date) => {
        this.setState({dateStartCredits: date})
    }
    handleDateEndCredits = (date) => {
        this.setState({dateEndCredits: date})
    }
    handleFindRange = () => {
        const {  dateStart, dateEnd } = this.state
        if (this.state.codes.length > 0) {
            this.filterCodesByDate(dateStart, dateEnd)
        } else {
            /*this.props.getCodes(dateStart, dateEnd, secuencialAccount).then( res => {
                this.setState({ codes: res.payload.MovimientosCuenta })
               }).catch( error => {
               }) */
        }
        
    }

    handleFindRangeDeposits = () => {
        try {
            const {  dateStartDeposits, dateEndDeposits, depositSelected } = this.state
            if (this.state.deposits.length > 0) {
                this.filterDepositsByDate(dateStartDeposits, dateEndDeposits)
            } else {
                this.props.getDepositsMovements(
                    {SecuencialDeposito: depositSelected.Secuencial, FechaInicio: dateStartDeposits,
                        FechaFin: dateEndDeposits, SecuencialEmpresa: 1}).then( res => {
                    this.setState({ deposits: res.payload })
                }).catch( error => {
                    //console.log('no se a podido encontrar codes', error)
                })
            }
        } catch (error) {
            //console.log(error)
        }
        
        
    }

    handleFindAccountCode = (value) => {
        const { Secuencial } = value
        const { dateStart, dateEnd } = this.state
        this.setState({ loading: true})
        this.setState({secuencialAccount: Secuencial, codes: []})
        this.props.getCodes('', '', Secuencial).then( res => {
            this.setState({ loading: false})
            this.setState({ codes: res.payload.data.MovimientosCuenta })
            this.filterCodesByDate(dateStart, dateEnd)
        }).catch( error => {
            //console.log('no se a podido encontrar codes', error)
        })
    }

    handleFindDeposit = (value) => {
        const { Secuencial } = value
        this.setState({depositSelected: value})
        const { dateStart, dateEnd } = this.state
        this.setState({ loading: true})
        this.setState({secuencialAccount: Secuencial, deposits: []})
        this.props.getDepositsMovements({SecuencialDeposito: Secuencial, FechaInicio: '', FechaFin: '', SecuencialEmpresa: 1 }).then( res => {
            this.setState({ loading: false})
            this.setState({ deposits: res.payload.data })
            this.filterDepositsByDate(dateStart, dateEnd)
        }).catch( error => {
            //console.log('no se a podido encontrar codes', error)
        })
    }


    
    handleFindRangeCredits = () => {
        try {
            
            const { dateStartCredits, dateEndCredits } = this.state
            this.setState({loadingCredits: true})
            const { credits } = this.state
            if (credits.length > 0) {
                this.filterCreditsByDate(dateStartCredits, dateEndCredits)
                this.setState({loadingCredits: false})
                // this.filterDatesCredits()
            } else {
                this.props.getCredits().then( res => {
                    const {payload} = res
                    this.setState({credits: payload.data.PagosPrestamo})
                    this.setState({loadingCredits: false})
                    this.filterCreditsByDate(dateStartCredits, dateEndCredits)
                }).catch(error => {
                    this.setState({loadingCredits: false})
                    //console.log('error al obtener creditos', error)
                    this.props.handleOpenSnack('No se ha podido obtener información, por favor intente nuevamente.', 'error')
                })
            }
        } catch (error) {
            //console.log(error)
        }
        
    }
    // reders
    render() {
        const { classes, balances, credits  } = this.props
        const { codes, dateValue, loading, loadingCredits, deposits } = this.state
        return (
            // user &&
            <div  >
                <StandardAccordion title = { 'Movimientos de cuenta'} defaultExpanded onChange={(index) =>{/* console.log(index)*/}}>
                    <div style = {{width: '100%'}}>
                        <CodeList
                                {...this.state}
                                codes = { codes }
                                loading = { loading }
                                balances = { balances }
                                classes = { classes }
                                selectCode = { this.handleSelectCode }
                                dateValue = { dateValue }
                                handleDateStart = { this.handleDateStart }
                                handleDateEnd = { this.handleDateEnd }
                                findDataRange = { this.handleFindRange }
                                findAccountCode = { this.handleFindAccountCode }
                                onChangePaginationCodes = { this.onChangePaginationCodes }
                        />
                        <br/>
                    </div>
                </StandardAccordion>
                <StandardAccordion title = { 'Créditos'} onChange={(index) => {/* console.log(index) */}}>
                    <div style = {{width: '100%'}}>
                        {
                            (credits.infoPayment.length > 0 ) ?
                            <CreditList 
                                {...this.state}
                                loading = { loadingCredits }
                                credits = { 
                                    this.state.credits.length > 0 ?
                                    this.state.credits :
                                    []
                                }
                                classes = { classes }
                                dateValue = { dateValue }
                                handleDateStart = { this.handleDateStartCredits }
                                handleDateEnd = { this.handleDateEndCredits }
                                findDataRange = { this.handleFindRangeCredits }
                            /> :
                            <Alert severity="info">No existen Créditos</Alert>
                        }
                        
                    </div>
                </StandardAccordion>
                <StandardAccordion title = { 'Depositos Plazo Fijo'} onChange={() => ({})}>
                    <div style = {{width: '100%'}}>
                        {
                            (this.props.deposits.info.length > 0) ?
                            <DepositList
                                {...this.state}
                                deposits = { deposits}
                                depositSelected = { this.props.deposits.info }
                                codes = { codes }
                                loading = { loading }
                                balances = { balances }
                                classes = { classes }
                                selectDeposit = { this.handleSelectDeposit }
                                dateValue = { dateValue }
                                handleDateStart = { this.handleDateStartDeposits }
                                handleDateEnd = { this.handleDateEndDeposits }
                                findDataRange = { this.handleFindRangeDeposits }
                                findDeposit = { this.handleFindAccountCode }
                                onChangePaginationDeposits = { this.onChangePaginationDeposits }
                            /> :
                            <Alert severity="info">No existen Depositos</Alert>
                        }
                        
                    </div>
                </StandardAccordion>
            </div>
        );
    }
}

CodesContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    // user: PropTypes.object.isRequired,
    // fixedHeightPaper: PropTypes.string.isRequired,
};

const mapDispatchToProps = state => {
    const {codes } = state
    return { codes }
}

export default connect(mapDispatchToProps, {
    getCodes,
    getCredits,
    getDepositsMovements
} )(CodesContainer)
// export default CodesContainer;